import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Advice, Button } from '@Sage/hoi-poi-ui';
import TextField from 'containers/components/Fields/Text';
import { getLiteral } from 'utils/getLiteral';

const MailChimpTextField = ({ onChange, value, switchField, newListExist }) => (
    <div className="fm-mailchimp-textfield">
        <div className="fm-mailchimp-textfield__row">
            <TextField
                className="fm-mailchimp-textfield__input"
                hint={getLiteral('placeholder_mailchimp_export')}
                onChange={onChange}
                value={value}
            />
            <Button
                className="fm-mailchimp-textfield__cancel"
                onClick={switchField}
                type="secondary"
            >
                {getLiteral('action_cancel')}
            </Button>
        </div>
        {newListExist && (
            <Advice showCollapse={false} showIcon type="error">
                {getLiteral('label_mailchimp_duplicated_list_name')}
            </Advice>
        )}
    </div>
);

MailChimpTextField.propTypes = {
    newListExist: PropTypes.bool,
    onChange: PropTypes.func,
    switchField: PropTypes.func,
    value: PropTypes.string,
};

export default memo(MailChimpTextField);
